import { Rocket, ExternalLink } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { DeploymentDto } from "@shared/types/WorkOrderDto";
import { getDeploymentStateConfig } from "./utils";

export function DeploymentCard({ deployment }: { deployment: DeploymentDto }) {
  const stateConfig = getDeploymentStateConfig(deployment.state);
  const StateIcon = stateConfig.icon;

  return (
    <a
      href={deployment.link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-start gap-3 p-3 rounded-lg border border-border/50 hover:bg-card/50 hover:border-primary/30 transition-all"
    >
      <div className="w-8 h-8 rounded-lg bg-green-500/10 flex items-center justify-center shrink-0">
        <Rocket className="h-4 w-4 text-green-500" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium truncate">{deployment.name}</p>
          <Badge variant="outline" className="text-xs">
            <StateIcon className={`h-3 w-3 mr-1 ${stateConfig.className}`} />
            {stateConfig.label}
          </Badge>
        </div>
        <div className="flex items-center gap-2 mt-1 text-xs text-muted-foreground">
          <span>{deployment.repo}</span>
          <span>•</span>
          <span>Branch: {deployment.branch}</span>
        </div>
      </div>
      <ExternalLink className="h-4 w-4 text-muted-foreground shrink-0" />
    </a>
  );
}
